import { createSelector } from 'reselect';
import flatMap from 'lodash/flatMap';

import { deepKeysToCamel } from 'js-utils/transformation';

const getEntities = ({ organizers }) => organizers.entities;

export const getOrganizerEntities = createSelector(
    [getEntities],
    (organizers) => organizers,
);

export const getPlainOrganizerEntities = createSelector(
    [getEntities],
    (entities) => {
        const organizers = flatMap(entities, (organizers, categoryId) =>
            organizers.map(({ organizer, event }) => ({
                sampleEvent: event,
                ...organizer,
                categoryId,
            })),
        );

        return deepKeysToCamel(organizers);
    },
);
